import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@mui/material/Tooltip';
import './valueDisplay.scss'

function ValueDisplay({text}) {
    return (
        <Tooltip title={text} placement="top">
            <p className="value">{text}</p>
        </Tooltip>
    );
}

ValueDisplay.propTypes = {
  text: PropTypes.string.isRequired,
};

export default ValueDisplay;
